// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bk9q4","title":"styles_title__HvM53","subTitle":"styles_subTitle__EkBZi","BackBtn":"styles_BackBtn__vvBjX"};